<!-- =========================================================================================
    File Name: AgGridTable.vue
    Description: Ag Grid table
    ----------------------------------------------------------------------------------------
    Item Name:
    Author:
    Author URL:
========================================================================================== -->

<template>
  <div>
    <!-- DEPARTMENTS LIST -->
    <div id="ag-grid-demo">
      <vx-card>
        <!-- TABLE ACTION ROW -->
        <div class="flex flex-wrap justify-between items-center form-title">
          <h4>Organization</h4>
          <div class="flex flex-wrap justify-end items-center">
            <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
            <div
              class="
                flex flex-wrap
                items-center
                justify-between
                ag-grid-table-actions-right
              "
            >
              <vs-input
                class="mb-4 md:mb-0 mr-4"
                v-model="searchQuery"
                @input="updateSearchQuery"
                placeholder="Search..."
              />
              <!-- <vs-button
                class="mb-4 md:mb-0 text-hover-white"
                @click="gridApi.exportDataAsCsv()"
              >Export as CSV</vs-button>-->
              <!-- <vx-tooltip text="Export Excel">
                <a
                  :href="
                    excelurl +
                      `/v2/users/excel/download?organization_id=${organization_id}&token=${temp_token}`
                  "
                  target="_blank"
                  v-if="this.archive != 'archive'"
                >
                  <vs-button class="px-4">
                    <span class="d-inline-flex pr-5 text-white">Export</span>
                    <img
                      src="@/assets/images/icons/export-excel.svg"
                      class="d-inline-flex"
                      height="20"
                      width="20"
                    />
                  </vs-button>
                </a>
              </vx-tooltip>

              <vx-tooltip text="Export Archive Excel">
                <a
                  :href="
                    excelurl +
                      `/v2/users/excel/download?organization_id=${organization_id}&token=${temp_token}&archive=1&search=${searchQuery}`
                  "
                  target="_blank"
                  v-if="this.archive == 'archive'"
                >
                  <vs-button class="px-4">
                    <span class="d-inline-flex pr-5 text-white">Export</span>

                    <img
                      src="@/assets/images/icons/export-excel.svg"
                      class="d-inline-flex"
                      height="20"
                      width="20"
                    />
                  </vs-button>
                </a>
              </vx-tooltip>-->
            </div>
          </div>
        </div>
        <ag-grid-vue
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="users"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :floatingFilter="false"
          :paginationPageSize="paginationPageSize"
          :pagination="true"
          :suppressPaginationPanel="true"
        ></ag-grid-vue>
        <vs-pagination
          :total="totalPages"
          :max="maxPageNumbers"
          v-model="currentPage"
        />
      </vx-card>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import contacts from "../../ui-elements/ag-grid-table/data.json";
import OrganizationService from "@/services/OrganizationService.js";
import organizationStatus from "./organizationStatus";
import orgResendCredential from "./orgResendCredential";
import organizationAdvancedCash from "./organizationAdvancedCash";
import organizationCreditNote from "./organizationCreditNote";
import organizationDigiSign from "./organizationDigiSign";
import organizationPOActive from "./organizationPOActive";
import DatetimePickerStartEnd from "@/views/components/extra-components/datetime-picker/DatetimePickerStartEnd.vue";
const VxTour = () => import("@/components/VxTour.vue");
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import organizationArchive from "./organizationArchive.vue";
import SearchService from "@/services/searchService.js";
import editOrganization from "./editOrganization.vue";
import organizationAgreement from "./organizationAgreement.vue";
import organizationDetails from "./organizationDetails.vue";
import { BASEURL } from "@/config/index.js";
export default {
  components: {
    AgGridVue,
    VxTour,
    DatetimePickerStartEnd,
  },
  props: ["listType"],
  data() {
    return {
      excelurl: BASEURL,
      organization_id: "",
      totalPages: 0,
      archive: this.listType,
      User: "Select User",
      users: [],
      searchQuery: "",
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true,
      },
      fromDate: null,
      toDate: null,
      configFromdateTimePicker: {
        minDate: new Date(),
        maxDate: null,
      },
      configTodateTimePicker: {
        minDate: null,
      },
      cityOptions: [
        { text: "New York", value: "new-york" },
        { text: "Chicago", value: "chicago" },
        { text: "San Francisco", value: "san-francisco" },
        { text: "Boston", value: "boston" },
      ],
      columnDefs: [],
      contacts: contacts,
    };
  },
  watch: {
    "$store.state.windowWidth"(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("email", null);
      } else this.gridOptions.columnApi.setColumnPinned("email", "left");
    },
  },
  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 100;
    },
    // totalPages() {
    //   if (this.gridApi) return this.gridApi.paginationGetTotalPages();
    //   else return 0;
    // },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        // if (this.gridApi) return this.gridApi.paginationGoToPage(val - 1);
        if (val) {
          this.getUserList(val);
          return val;
        } else return 1;
      },
    },
  },
  methods: {
    // updateSearchQuery(val) {
    //   this.gridApi.setQuickFilter(val);
    // },
    updateSearchQuery(val) {
      SearchService.getAllSerchResultV2(val, "users", null)
        .then((response) => {
          const { data } = response;
          if (data.data.length > 0 && data.Status) {
            this.users = data.data;
          } else {
            this.users = [];
            // this.$vs.notify({
            //   title: "Search data not found",
            //   text: data.Message,
            //   iconPack: "feather",
            //   icon: "check_box",
            //   color: "warning"
            // });
          }
        })
        .catch((error) => {
          this.$vs.notify({
            title: "Data Not Found",
            text: error.Message,
            iconPack: "feather",
            icon: "check_box",
            color: "warning",
          });
        });
    },
    onFromChange(selectedDates, dateStr, instance) {
      this.$set(this.configTodateTimePicker, "minDate", dateStr);
    },
    onToChange(selectedDates, dateStr, instance) {
      this.$set(this.configFromdateTimePicker, "maxDate", dateStr);
    },

    getUserList: function (currentPage) {
      let filter = {
        page: currentPage,
        contracy_active: 1,
      };
      if (this.archive == "archive") {
        filter["archive"] = true;
      }
      OrganizationService.getAllOrganization(filter)
        .then((response) => {
          const { data } = response;
          if (data.err || data.Status == false) {
          } else {
            this.users = data.data;
            this.totalPages = data.pagination.last_page;
            this.gridApi.sizeColumnsToFit();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  beforeMount() {
    this.organization_id = localStorage.getItem("OrganizationID");
    eventBus.$on("refreshorganizationTable", (e) => {
      this.getUserList(this.currentPage);
    });
  },

  mounted() {
    this.columnDefs = [
      {
        headerName: "Image",
        field: "organization_logo",
        width: 100,
        sortable: false,
        suppressSizeToFit: true,
        cellRenderer: function (params) {
          if (
            params.data.organization_logo &&
            params.data.organization_logo.length > 4
          ) {
            return `<img  class="img-rounded" src=${params.data.organization_logo} />`;
          } else {
            return `<img  class="img-rounded" src="https://api.gokozo.com/uploads/8e834a837c03cb52_org.png"/>`;
          }
        },
      },
      {
        headerName: "Name",
        field: "organization_name",
        width: 200,
        // checkboxSelection: true,
        // headerCheckboxSelectionFilteredOnly: true,
        // headerCheckboxSelection: true,
      },
      {
        headerName: "Email",
        field: "organization_email",
        width: 275,
      },
      {
        headerName: "Organization Type",
        field: "",
        width: 150,
        cellRenderer: function (params) {
          // console.log(params);
          if (params.data.organization_type == 0) {
            return "Only Kozo";
          } else if (params.data.organization_type == 2) {
            return "Both";
          } else if (params.data.organization_type == 1) {
            return "Only Contract";
          }
          // if (params.value == "") {
          //   return "";
          // }
          // if (params.value == null) {
          //   return "Select WorkType";
          // } else {

          // }
        },
      },
      {
        headerName: "Tally Status",
        field: "",
        width: 100,
        sortable: false,
        //  hide: this.archive == "archive" ? true : false,

        cellStyle: { "text-align": "center" },
        cellRendererFramework: organizationStatus,
      },
      {
        headerName: "Advance Cash",
        field: "",
        width: 100,
        sortable: false,
        //  hide: this.archive == "archive" ? true : false,

        cellStyle: { "text-align": "center" },
        cellRendererFramework: organizationAdvancedCash,
      },
      {
        headerName: "Credit Note",
        field: "",
        width: 100,
        sortable: false,
        //  hide: this.archive == "archive" ? true : false,

        cellStyle: { "text-align": "center" },
        cellRendererFramework: organizationCreditNote,
      },
      {
        headerName: "Digi Sign",
        field: "",
        width: 100,
        sortable: false,
        //  hide: this.archive == "archive" ? true : false,

        cellStyle: { "text-align": "center" },
        cellRendererFramework: organizationDigiSign,
      },
      {
        headerName: "PO Active",
        field: "",
        width: 100,
        sortable: false,
        cellStyle: { "text-align": "center" },
        cellRendererFramework: organizationPOActive,
      },
      {
        headerName: "Edit",
        field: "",
        width: 95,
        sortable: false,
        hide: this.archive == "archive" ? true : false,
        cellStyle: { "text-align": "center" },
        cellRendererFramework: editOrganization,
      },

      {
        headerName: "Resend Credential",
        field: "",
        width: 150,
        sortable: false,
        hide: this.archive == "archive" ? true : false,
        cellStyle: { "text-align": "center" },
        cellRendererFramework: orgResendCredential,
      },
      // {
      //   headerName: this.archive == "archive" ? "Unarchive" : "Archive",
      //   field: this.archive ? "1" : "4",
      //   width: this.archive ? 140 : 104,
      //   sortable: false,
      //   cellStyle: { "text-align": "center" },
      //   cellRendererFramework: userArchive
      // }
    ];

    if (this.checkPermission(["Users", "GET"])) {
      this.getUserList(this.currentPage);
    }
    // this.agGrid.columnApi.setColumnsVisible(["Status"], false);

    this.gridApi = this.gridOptions.api;
  },
};
</script>
<style>
.img-rounded {
  border-radius: 50%;
  max-width: 40px;
  margin-top: 2px;
  height: 40px;
  object-fit: cover;
  object-position: center;
}
</style>
